/** AP05 copy (one group per control; a ticket edits only its own file). */
export const ap05PtBr = {
  title: 'Estimativas em aberto',
  description:
    'Provisões lançadas sem baixa e sem decisão de manter neste período, e propostas ainda não confirmadas.',
  prerequisite: '',
  detail: {
    undecided: {
      title: 'Estimativas lançadas sem decisão',
      subtitle:
        'Mantenha ou reverta cada estimativa lançada antes de fechar o período. Uma decisão de manter perde a validade quando a estimativa muda.',
      restricted_one: '{{count}} estimativa em aberto. Acesso à provisão necessário para revisar.',
      restricted_other:
        '{{count}} estimativas em aberto. Acesso à provisão necessário para revisar.',
    },
    proposed: {
      title: 'Propostas não confirmadas (preparação)',
      note: 'Preparação, não despesa: propostas não confirmadas não entram no valor do controle nem na despesa do período.',
      badge: 'Preparação, não despesa',
      item: 'Proposta de provisão',
      competency: 'Competência {{month}}',
      proposedOn: 'Proposta em {{date}}',
      ageToday: 'hoje',
      age_one: 'há {{count}} dia',
      age_other: 'há {{count}} dias',
      noDate: 'Sem data da proposta',
      review: 'Revisar propostas',
      truncated:
        'Mostrando {{shown}} propostas de uma lista parcial. Abra a revisão para ver todas.',
    },
    observations: {
      proposalsNotEnabled_one: '{{count}} proposta em entidade sem provisão configurada',
      proposalsNotEnabled_other: '{{count}} propostas em entidade sem provisão configurada',
      keptWithoutDecision_one: '{{count}} mantida sem decisão registrada',
      keptWithoutDecision_other: '{{count}} mantidas sem decisão registrada',
    },
  },
};

export const ap05En: typeof ap05PtBr = {
  title: 'Open estimates',
  description:
    'Posted accruals not yet settled or kept in this period, and proposals not yet confirmed.',
  prerequisite: '',
  detail: {
    undecided: {
      title: 'Posted estimates without a decision',
      subtitle:
        'Keep or reverse each posted estimate before closing the period. A decision to keep stops holding when the estimate changes.',
      restricted_one: '{{count}} open estimate. Accrual access is required to review it.',
      restricted_other: '{{count}} open estimates. Accrual access is required to review them.',
    },
    proposed: {
      title: 'Unconfirmed proposals (preparation)',
      note: 'Preparation, not expense: unconfirmed proposals are not part of the control amount or of the period expense.',
      badge: 'Preparation, not expense',
      item: 'Accrual proposal',
      competency: 'Competency {{month}}',
      proposedOn: 'Proposed on {{date}}',
      ageToday: 'today',
      age_one: '{{count}} day ago',
      age_other: '{{count}} days ago',
      noDate: 'No proposal date',
      review: 'Review proposals',
      truncated:
        'Showing {{shown}} proposals from a partial list. Open the review to see them all.',
    },
    observations: {
      proposalsNotEnabled_one: '{{count}} proposal in an entity without a provision account',
      proposalsNotEnabled_other: '{{count}} proposals in an entity without a provision account',
      keptWithoutDecision_one: '{{count}} kept estimate without a recorded decision',
      keptWithoutDecision_other: '{{count}} kept estimates without a recorded decision',
    },
  },
};
